import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';

import '../../css/SingleScreens/ConsultationScreen.css';

import { StringUtils, ArrayUtils } from '../../utils';
import { History as history, Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ConsultationsActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Button, Errors } from  '../../components'

class ConsultationOptionsScreen extends Component {

  findAndSetConsultationLocation = () => {
    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    var consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;
    const client = consultation && consultation.primary_client ? consultation.primary_client : '';
    const token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';

    if (client && token) {
      this.props.practiceActions.getClientProviders(token, client, this.setConsultationLocation);
    }
  }

  setConsultationLocation = (allProviders) => {
    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    const consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    const practice_id  = consultation.practice_id;
    const providers    = allProviders || [];

    var locationID = '';

    providers.forEach((provider) => {
      const providerPractice = provider.practice_id;
      const providerLocation = provider.provider_location;
      if (providerPractice && providerPractice === practice_id && providerLocation) {
        locationID = providerLocation;
      }
    });

    this.setState({ ...this.state, consultation_location: locationID });
  }

  constructor(props) {
    super(props);
    this.findAndSetConsultationLocation();
    this.state = {
      displaySubjectOptions: false,
      selectedSubject: '',
      customSubject: '',
      message: '',
      medicalRecordSubject: '',
      medicalRecordBody: '',
      consultation_location: '',
      amount: 0,
      attachFrontDeskToResolve: false,
      attachMedicalRecordToResolve: false,
      taskAttached: false,
      recordAttached: false,
      validation: {},
      service_fee: null,
    }
  }

  componentDidMount() {
    let selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    let consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    let service_fee  = config.SERVICE_FEE || 0.08;

    if (consultation) {
      const finalAmount = consultation.final_amount;
      const inDollars   = finalAmount / 100;
      const cleaned     = Number(inDollars.toFixed(2));
      this.setState({ ...this.state, amount: cleaned, service_fee: service_fee })
    } else {
      this.setState({ ...this.state, service_fee: service_fee })
    }
  }

  renderSubjectOption = (label, value) => {
    const currentlySelectedSubject = this.state.selectedSubject || '';
    const isThisSelected = currentlySelectedSubject === value ? true : false;

    return <div className='consultation-front-desk-subject-option'
                onClick={ () => {
                  this.setState({ ...this.state, displaySubjectOptions: false, selectedSubject: value })
                }}>
      <span>{ label }</span>
    </div>
  }

  renderFrontDeskSection = (consultation, asAttachment) => {

    const subjectLabelMap = {
      'follow_up': 'Follow Up',
      'medications': 'Medications',
      'schedule': 'Schedule',
      'other': 'Other',
    }

    const frontDeskAccounts = this.props.practice.frontDeskUsers;
    const location = this.state.consultation_location;
    const locationHasFrontDesk = this.doesFrontDeskExistForLocation(frontDeskAccounts, consultation.location_id);
    const sectionTitle = asAttachment && asAttachment === true ? 'Attach Front Desk Task' : 'Create Front Desk Task';
    const buttonTitle  = asAttachment && asAttachment === true ? 'Attach Task' : 'Send To Front Desk';

    if (!locationHasFrontDesk) {
      return <div className="basic-container" style={{ alignItems: 'center'}}>
        <h5 style={{ marginBottom: 15 }}>{ sectionTitle }</h5>
        <div className='flex-container-column' style={{ alignItems: 'center' }}>
          <div className='flex-container-column' style={{ width: '70%' }}>
            <span style={{ marginLeft: 10, marginBottom: 2, fontSize: 15, color: 'grey' }}>This location does not have a Front Desk account associated with it. The Admin of the Practice can create a Front Desk account in order to active this functionalitiy.</span>
          </div>
          <div>
            <input  type="submit"
                    value="Cancel"
                    style={{ marginRight: 5, marginTop: 10 }}
                    className="button-clear"
                    onClick={ () => {
                      if (this.props.location.state.props.option === 'front_desk') {
                        NavigationActions.navigateBack();
                      }
                      if (this.props.location.state.props.option === 'resolve') {
                        this.setState({ ...this.state, attachFrontDeskToResolve: false })
                      }
                    }}
                  />
          </div>
        </div>

      </div>
    }

    return <div className="basic-container" style={{ alignItems: 'center'}}>
          <h5 style={{ marginBottom: 15 }}>{ sectionTitle }</h5>

          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <div className='flex-container-column' style={{ width: '70%' }}>
              <span style={{ marginLeft: 10, marginBottom: 2, fontSize: 15 }}>Subject</span>
              { this.state.displaySubjectOptions ? <div>
                                                  { this.renderSubjectOption(subjectLabelMap['follow_up'], 'follow_up') }
                                                  { this.renderSubjectOption(subjectLabelMap['medications'], 'medications') }
                                                  { this.renderSubjectOption(subjectLabelMap['schedule'], 'schedule') }
                                                  { this.renderSubjectOption(subjectLabelMap['other'], 'other') }
                                                   </div>
                                                 : <div className='consultation-front-desk-subject-option' style={{ borderColor: this.state.selectedSubject ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, displaySubjectOptions: true }) }}>
                                                     <span>{ subjectLabelMap[this.state.selectedSubject] || 'Select Subject' }</span>
                                                   </div> }

              { this.state.selectedSubject !== 'other'  ? null
                                                        : <input  type="text"
                                                            className="input-default"
                                                            value={this.state.customSubject}
                                                            placeholder="Enter Custom Subject"
                                                            style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}
                                                            onChange={ (event) => { this.setState({ ...this.state, customSubject: event.target.value }) }}
                                                          /> }

              <span style={{ marginLeft: 10, marginTop: 10, marginBottom: 2, fontSize: 15 }}>Message</span>

              <textarea
                  placeholder="Enter a Message..."
                  rows="3"
                  type="text"
                  name="message"
                  className="consultations-message-input"
                  style={{ margin: 0 }}
                  value={this.state.message}
                  onChange={(event) => { this.setState({ ...this.state, message: event.target.value  }) }}
                >
                </textarea>

                <Errors validation={this.state.validation} style={{ marginBottom: 0, marginTop: 20 }} />
                <div className="flex-container flex-center-justify" style={{ marginTop: 20 }}>
                  <input  type="submit"
                          value="Cancel"
                          style={{ marginRight: 5 }}
                          className="button-clear"
                          onClick={ () => {
                            if (this.props.location.state.props.option === 'front_desk') {
                              NavigationActions.navigateBack();
                            }
                            if (this.props.location.state.props.option === 'resolve') {
                              this.setState({ ...this.state, attachFrontDeskToResolve: false })
                            }
                          }}
                        />
                  <input  type="submit"
                          value={buttonTitle}
                          className="button-default"
                          style={{ marginRight: 5 }}
                          onClick={ () => {

                            const displayError =  !subjectLabelMap[this.state.selectedSubject]
                                                  || (subjectLabelMap[this.state.selectedSubject] === 'other' && !this.state.customSubject)
                                                  || !this.state.message ? true : false;

                            if (displayError) {
                              const validation = { valid: false, errors: ['Subject and Message are required fields'], fields: {} }
                              this.setState({ ...this.state, validation: validation });
                              return;
                            }

                            if (asAttachment && asAttachment === true) {
                              this.setState({ ...this.state, taskAttached: true, validation: {} });
                            } else {
                              this.sendToFrontDeskAction(consultation);
                            }
                          }}
                        />
                </div>

            </div>
          </div>

        </div>
  }

  renderMedicalRecordSection = (consultation, asAttachment) => {

    var practiceInfo = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    var practice_id = consultation.practice_id || '';
    var isBehavior  = false;

    if (practiceInfo && practiceInfo.type === 'BEHAVIOR' && practiceInfo._id === practice_id) {
      isBehavior = true;
    }

    const attachSectionTitle = isBehavior ? 'Attach Note' : 'Attach Medical Record';
    const createSectionTitle = isBehavior ? 'Create Note' : 'Create Medical Record'

    const attachButtonTitle  = isBehavior ? 'Attach Note' : 'Attach Record';
    const createButtonTitle  = isBehavior ? 'Create Note' : 'Create Record';

    const sectionTitle = asAttachment && asAttachment === true ? attachSectionTitle : createSectionTitle;
    const buttonTitle  = asAttachment && asAttachment === true ? attachButtonTitle  : createButtonTitle;

    return <div className="basic-container" style={{ alignItems: 'center'}}>
      <h5 style={{ marginBottom: 15 }}>{ sectionTitle }</h5>

      <div className='flex-container-column' style={{ alignItems: 'center' }}>
        <div className='flex-container-column' style={{ width: '70%' }}>
          { isBehavior ? null : <span style={{ marginLeft: 10, marginBottom: 2, fontSize: 15 }}>Notes</span> }
          <textarea
              placeholder="Enter Notes..."
              rows="3"
              type="text"
              name="message"
              className="consultations-message-input"
              style={{ margin: 0 }}
              value={this.state.medicalRecordBody}
              onChange={(event) => { this.setState({ ...this.state, medicalRecordBody: event.target.value  }) }}
            >
            </textarea>

            <Errors validation={this.state.validation} style={{ marginBottom: 0, marginTop: 20 }} />
            <div className="flex-container flex-center-justify" style={{ marginTop: 20 }}>
              <input  type="submit"
                      value="Cancel"
                      style={{ marginRight: 5 }}
                      className="button-clear"
                      onClick={ () => {
                        if (this.props.location.state.props.option === 'medical_record') {
                          NavigationActions.navigateBack();
                        }
                        if (this.props.location.state.props.option === 'resolve') {
                          this.setState({ ...this.state, attachMedicalRecordToResolve: false })
                        }
                      }}
                    />
              <input  type="submit"
                      value={buttonTitle}
                      className="button-default"
                      style={{ marginRight: 5 }}
                      onClick={ () => {

                        const displayError =  !this.state.medicalRecordBody ? true : false;

                        if (displayError) {
                          const validation = { valid: false, errors: ['Notes is a required field'], fields: {} }
                          this.setState({ ...this.state, validation: validation });
                          return;
                        }

                        if (asAttachment && asAttachment === true) {
                          this.setState({ ...this.state, recordAttached: true, validation: {} });
                        } else {
                          this.createMedicalRecordAction(consultation);
                        }
                      }}
                    />
            </div>
        </div>
      </div>

    </div>
  }

  renderResolveSection = (consultation) => {

    var practiceInfo = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    var practice_id = consultation.practice_id || '';
    var isBehavior  = false;

    if (practiceInfo && practiceInfo.type === 'BEHAVIOR' && practiceInfo._id === practice_id) {
      isBehavior = true;
    }

    const hideChargeInfo = consultation && consultation.no_charge ? true : false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">
          <h5 style={{ marginBottom: 15 }}>Resolve Consultation</h5>

          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <div className='flex-container-column' style={{ width: '70%' }}>

              { hideChargeInfo ? null : <span style={{ marginLeft: 10, marginBottom: 2, fontSize: 15 }}>Charge Amount</span> }

              { hideChargeInfo ? null : <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'center' }}>
                <span className="fas fa-dollar-sign" style={{ fontSize: 20, color: '#1dc2ff', marginRight: 5 }}></span>
                <input  className="input-default"
                        style={{ margin: 10, marginLeft: 0, textAlign: 'center' }}
                        placeholder="Enter Charge Amount"
                        value={this.state.amount}
                        type="number"
                        onChange={ (event) => {
                          this.setState({ ...this.state, amount: event.target.value })
                        }}
                    />
              </div> }

              { true ? null : <div className='flex-container-row' style={{ justifyContent: 'center', alignItems: 'center', marginTop: hideChargeInfo ? 0 : 15 }}>

                { this.state.taskAttached ? null
                :  <input type='submit'
                       className='button-clear-blue'
                       value='Attach Front Desk Task'
                       onClick={ () => { this.setState({ ...this.state, attachFrontDeskToResolve: true }) }}
                      />
                }
                { this.state.taskAttached || this.state.recordAttached ? null : <span style={{ marginRight: 5, marginLeft: 5, color: '#e7e7e7' }}>|</span> }
                { this.state.recordAttached ? null
                : <input type='submit'
                       className='button-clear-blue'
                       value={ isBehavior ? 'Attach Note' : 'Attach Medical Record' }
                       onClick={ () => { this.setState({ ...this.state, attachMedicalRecordToResolve: true }) }}
                      /> }
              </div> }

            </div>
          </div>

        </div>

        { this.state.attachFrontDeskToResolve     && this.state.taskAttached    === false ? this.renderFrontDeskSection(consultation, true)     : null }
        { this.state.attachMedicalRecordToResolve && this.state.recordAttached  === false ? this.renderMedicalRecordSection(consultation, true) : null }
        { this.renderResolveSummary(consultation) }
      </div>
    </div>
  }

  renderResolveSummary = (consultation) => {

    var practiceInfo = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    var practice_id = consultation.practice_id || '';
    var isBehavior  = false;

    if (practiceInfo && practiceInfo.type === 'BEHAVIOR' && practiceInfo._id === practice_id) {
      isBehavior = true;
    }

    const subjectLabelMap = {
      'follow_up': 'Follow Up',
      'medications': 'Medications',
      'schedule': 'Schedule',
      'other': 'Other',
    }

    const client     = consultation && consultation.primary_client ? consultation.primary_client : '';
    const clientInfo = ArrayUtils.getSingleObject(consultation.client);
    const displayAttachedTask = this.state.taskAttached === true ? true : false;
    const displayAttachedRecord = this.state.recordAttached === true ? true : false;
    const taskSubject = this.state.selectedSubject === 'other' ? this.state.customSubject : subjectLabelMap[this.state.selectedSubject];

    return <div className="basic-container">
          <h5 style={{ marginBottom: 15 }}>Consultation Summary</h5>

          <div className='flex-container-row'>
            { displayAttachedTask ? <div className='flex-container-row'
                                         style={{ alignItems: 'center', justifyContent: 'flex-start', marginBottom: 10 }}
                                         onClick={ () => { this.setState({ ...this.state, taskAttached: false }) }}>
                                      <span className='consultation-summary-attachment flex-container-row' style={{ alignItems: 'center' }}>
                                        <span className="fas fa-paperclip" style={{ fontSize: 20, color: '#1dc2ff', marginRight: 5 }}></span>
                                        <div className='flex-container-column' style={{ marginRight: 10, marginLeft: 10 }}>
                                          <span style={{ fontSize: 14 }}>{ taskSubject }</span>
                                          <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>FRONT DESK TASK</span>
                                        </div>
                                      </span>
                                    </div>
                                  : null }

            { displayAttachedRecord ? <div className='flex-container-row'
                                           style={{ alignItems: 'center', justifyContent: 'flex-start', marginBottom: 10, marginLeft: displayAttachedTask ? 8 : 0 }}
                                           onClick={ () => { this.setState({ ...this.state, recordAttached: false }) }}>
                                        <span className='consultation-summary-attachment flex-container-row' style={{ alignItems: 'center' }}>
                                          <span className="fas fa-paperclip" style={{ fontSize: 20, color: '#1dc2ff', marginRight: 5 }}></span>
                                          <div className='flex-container-column' style={{ marginRight: 10, marginLeft: 10 }}>
                                            <span style={{ fontSize: 14 }}>{ this.state.medicalRecordSubject }</span>
                                            <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>{ isBehavior ? 'NOTE' : 'MEDICAL RECORD' }</span>
                                          </div>
                                        </span>
                                      </div>
                                    : null }
          </div>

          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div className='flex-container-column'>
              <span style={{ fontSize: 14 }}>{ StringUtils.displayName(clientInfo) }</span>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>{ 'CLIENT' }</span>
              <div className='flex-container-row'>
                <div className='flex-container-column' style={{ marginRight: 15 }}>
                  <span style={{ fontSize: 14, marginTop: 5 }}>{ '$' + this.state.amount }</span>
                  <span style={{ fontSize: 10, color: 'grey', marginTop: -3, fontWeight: 'bold' }}>CHARGE AMOUNT</span>
                </div>
                <div className='flex-container-column' style={{ marginRight: 15 }}>
                  <span style={{ fontSize: 14, marginTop: 5, color: 'grey' }}>{ '+' }</span>
                </div>
                <div className='flex-container-column'>
                  <span style={{ fontSize: 14, marginTop: 5 }}>{ '$' + (this.state.amount * this.state.service_fee).toFixed(2) }</span>
                  <span style={{ fontSize: 10, color: 'grey', marginTop: -3, fontWeight: 'bold' }}>SERVICE FEE</span>
                </div>
              </div>
              <span style={{ fontSize: 14, marginTop: 5 }}>{ '$' + (this.state.amount * (1 + this.state.service_fee)).toFixed(2) }</span>
              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3, fontWeight: 'bold' }}>FINAL CHARGE TO CLIENT</span>
            </div>
            <div>
              <Button value="Resolve Consultation"
                      loading={this.props.loading && this.props.loading.resolveConsultation}
                      style={{ marginRight: 5, padding: 10, paddingRight: 15, paddingLeft: 15 }}
                      onClick={ () => {
                        const token = this.props.user && this.props.user.auth.token ? this.props.user.auth.token : '';
                        const finalAmount = parseInt(this.state.amount * 100);
                        const amountInCents = finalAmount;
                        let unassigned_consultation = consultation && consultation.primary_assignee && consultation.primary_assignee === 'unassigned' ? true : false;

                        const resolveParameters = {
                          amount: amountInCents,
                          payment_type: consultation.payment_method,
                        }

                        if (unassigned_consultation) {
                          this.props.toastActions.displayInfo('Assign a provider to the consultation before resolving. The consultation is currently unassigned.')
                          return;
                        }

                        if (token) {
                          this.props.consultationsActions.resolveConsultation(token, consultation._id, resolveParameters, () => { this.resolveSuccessAction(consultation) });
                        }
                      }}
                    />
            </div>
          </div>

        </div>
  }

  renderConsultationOptionsSection = (consultation) => {
    const props = this.props.location.state.props;

    if (props.option === 'front_desk') {
      return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          { this.renderFrontDeskSection(consultation) }
        </div>
      </div>
    } else if (props.option === 'medical_record') {
      return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          { this.renderMedicalRecordSection(consultation) }
        </div>
      </div>
    } else if (props.option === 'resolve') {
      return this.renderResolveSection(consultation);
    }
  }

  render() {

    const selectedConsultation = this.props.consultations && this.props.consultations.selectedConsultation ? this.props.consultations.selectedConsultation : {};
    var consultation =  this.props.consultations
                          && this.props.consultations.allConsultations
                          && this.props.consultations.allConsultations[selectedConsultation._id] ? this.props.consultations.allConsultations[selectedConsultation._id] : selectedConsultation;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Consultation" />
        { this.renderConsultationOptionsSection(consultation) }
      </div>
    );
  }

  createMedicalRecordAction = (consultation, removeCallback) => {

    const patient_id  = consultation.patient_id;
    const provider_id = consultation.primary_assignee;
    const client_id   = consultation.primary_client;
    const practice_id = consultation.practice_id;
    const subject     = this.state.medicalRecordSubject;
    const body        = this.state.medicalRecordBody;
    const consultation_id = consultation._id;

    var medical_record = {
      practice_id: practice_id,
      patient_id: patient_id,
      client_id: client_id,
      provider_id: provider_id,
      consultation_id: consultation_id,
      subject: subject,
      body: body,
    }

    const token = this.props.user.auth.token;
    const user_id  = this.props.user && this.props.user.auth.user_id ? this.props.user.auth.user_id : '';

    if (user_id) {
      medical_record.provider_id = user_id;
    }

    this.props.consultationsActions.createMedicalRecord(token, medical_record, removeCallback ? null : this.successAction);
  }

  sendToFrontDeskAction = (consultation, removeCallback) => {
    const token = this.props.user.auth.token;
    const user_id  = this.props.user && this.props.user.auth.user_id ? this.props.user.auth.user_id : '';
    const fronDeskTaskObj = this.getFrontDeskTask(user_id, consultation);

    this.props.consultationsActions.sendTaskToFrontDesk(token, fronDeskTaskObj, removeCallback ? null : this.successAction);
  }

  getFrontDeskTask = (user_id, consultation) => {

    const frontDesks = this.props.practice.frontDeskUsers;
    const location   = this.state.consultation_location;
    const assignee   = this.getFrontDeskAssignee(frontDesks, consultation.location_id);
    const assigneeId = assignee && assignee.user_id ? assignee.user_id : '';

    const subjectLabelMap = {
      'follow_up': 'Follow Up',
      'medications': 'Medications',
      'schedule': 'Schedule',
      'other': 'Other',
    }

    var message = this.state.message;
    var subject = this.state.selectedSubject;
    subject = subject === 'other' ? this.state.customSubject : subjectLabelMap[subject];

    const frontDeskTask = {
      assigner: user_id,
      assignee: assigneeId,
      subject: subject,
      message: message,
      consultation_id: consultation._id,
      completed: false,
    }

    return frontDeskTask;
  }

  getFrontDeskAssignee = (frontDesks, location) => {
    var assignee = null;
    var fdUsers  = frontDesks || [];

    fdUsers.forEach((user) => {
      if (user.location_id === location) {
        assignee = user;
      }
    })

    return assignee;
  }

  doesFrontDeskExistForLocation = (frontDeskAccounts, location) => {
    var hasFrontDesk = false;
    var accounts    = frontDeskAccounts || [];
    var location_id = location || '';

    accounts.forEach((account) => {
      if (account.location_id === location_id) {
        hasFrontDesk = true;
      }
    })

    return hasFrontDesk;
  }

  resolveSuccessAction = (consultation) => {
    if (this.state.taskAttached || this.state.recordAttached) {
      if (this.state.taskAttached) {
        this.sendToFrontDeskAction(consultation, true);
      }
      if (this.state.recordAttached) {
        this.createMedicalRecordAction(consultation, true);
      }
    }
    this.successAction();
  }

  successAction = () => {
    NavigationActions.navigateBack();
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
    consultations: state.consultations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationOptionsScreen)
